import { Box, Button, Container, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

import { overlineSx, pillButtonSx } from "../styles/sectionStyles"

const PageCtaBand = ({ overline, title, description, actions, gradientPosition = "80% 50%" }) => (
    <Box
        component="section"
        sx={{
            py: { xs: 6, md: 7 },
            background: "#000435",
            color: "#fff",
            position: "relative",
            overflow: "hidden",
        }}
    >
        <Box
            sx={{
                position: "absolute",
                inset: 0,
                background: `radial-gradient(ellipse 60% 80% at ${gradientPosition}, rgba(0, 163, 255, 0.12), transparent 55%)`,
                pointerEvents: "none",
            }}
        />

        <Container maxWidth="lg" sx={{ position: "relative" }}>
            <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "flex-start", md: "center" }}
                justifyContent="space-between"
                spacing={3}
                data-aos="fade-up"
                data-aos-duration="800"
            >
                <Box maxWidth={520}>
                    <Typography variant="overline" sx={overlineSx}>
                        {overline}
                    </Typography>
                    <Typography variant="h4" fontWeight={800} lineHeight={1.15} mt={1} mb={1.5}>
                        {title}
                    </Typography>
                    <Typography variant="body1" sx={{ opacity: 0.78, lineHeight: 1.7 }}>
                        {description}
                    </Typography>
                </Box>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} flexShrink={0}>
                    {actions.map((action) => (
                        <Button
                            key={action.label}
                            component={action.href ? Link : undefined}
                            to={action.href}
                            target={action.external ? "_blank" : undefined}
                            rel={action.external ? "noopener noreferrer" : undefined}
                            variant={action.variant || "contained"}
                            color={action.color || "secondary"}
                            size="large"
                            onClick={action.onClick}
                            sx={{
                                ...pillButtonSx,
                                px: 3.5,
                                ...(action.variant === "outlined" && {
                                    borderColor: "rgba(0, 163, 255, 0.55)",
                                    color: "#fff",
                                    "&:hover": {
                                        borderColor: "#00A3FF",
                                        background: "rgba(0, 163, 255, 0.1)",
                                    },
                                }),
                            }}
                        >
                            {action.label}
                        </Button>
                    ))}
                </Stack>
            </Stack>
        </Container>
    </Box>
)

export default PageCtaBand
